/* The San Market theme: small, dependency-free scripts */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100);
    var withCommas = function (n, dec, thousands, decimal) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withCommas(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0, '.', ',');
        default: return withCommas(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  function drawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = routes.cart; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshDrawer() {
    return fetch(routes.root.replace(/\/$/, '') + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawerContent');
        var current = document.getElementById('CartDrawerContent');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
  }

  function changeLine(line, quantity, container) {
    if (container) container.classList.add('is-updating');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        updateCount(cart.item_count);
        return refreshDrawer();
      })
      .catch(function () { window.location.reload(); });
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.body.description || res.body.message || 'Sorry, that could not be added.';
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { window.alert(msg); }
          return;
        }
        return fetch(routes.cart + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCount(cart.item_count); return refreshDrawer(); })
          .then(openDrawer);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          if (!button.hasAttribute('data-sold-out')) button.disabled = false;
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-ajax-cart]') && drawer()) {
      e.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    var stepper = t.closest('[data-line-step]');
    if (stepper) {
      e.preventDefault();
      var line = stepper.closest('[data-line]');
      var qty = Number(line.getAttribute('data-qty')) + Number(stepper.getAttribute('data-line-step'));
      changeLine(line.getAttribute('data-line'), qty, line);
      return;
    }
    var remover = t.closest('[data-line-remove]');
    if (remover) {
      e.preventDefault();
      var l = remover.closest('[data-line]');
      changeLine(l.getAttribute('data-line'), 0, l);
      return;
    }

    var qtyBtn = t.closest('[data-qty-step]');
    if (qtyBtn) {
      var input = qtyBtn.parentElement.querySelector('input');
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(qtyBtn.getAttribute('data-qty-step')));
      input.value = next;
      return;
    }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-gallery]'), thumb.getAttribute('data-thumb')); return; }

    var facetToggle = t.closest('[data-facets-toggle]');
    if (facetToggle) {
      var panel = document.getElementById(facetToggle.getAttribute('aria-controls'));
      var open = panel.classList.toggle('is-open');
      facetToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      document.querySelectorAll('details[open].mobile-menu').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* ---------- Product gallery ---------- */
  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var main = gallery.querySelector('[data-main-image]');
    var thumb = gallery.querySelector('[data-thumb="' + mediaId + '"]');
    if (!main || !thumb) return;
    var img = thumb.querySelector('img');
    main.src = thumb.getAttribute('data-large');
    main.srcset = thumb.getAttribute('data-srcset') || '';
    main.alt = img ? img.alt : '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) {
      var on = b === thumb;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  /* ---------- Variant picker ---------- */
  function initProductForm(form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var root = form.closest('[data-product]') || document;

    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability(selected) {
      form.querySelectorAll('[data-option-group]').forEach(function (group, index) {
        group.querySelectorAll('input').forEach(function (input) {
          var test = selected.slice();
          test[index] = input.value;
          var exists = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          input.closest('label').classList.toggle('is-unavailable', !exists);
        });
      });
    }

    function update() {
      var selected = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });

      markAvailability(selected);
      form.querySelectorAll('[data-option-value]').forEach(function (el, i) { el.textContent = selected[i] || ''; });

      var button = form.querySelector('[data-add-button]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var giftAmount = root.querySelector('[data-gift-amount]');

      if (!variant) {
        if (button) { button.disabled = true; button.setAttribute('data-sold-out', ''); button.querySelector('span').textContent = 'Unavailable'; }
        return;
      }

      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (giftAmount) giftAmount.textContent = formatMoney(variant.price).replace(/\.00$/, '');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (button) {
        var label = button.querySelector('span');
        if (variant.available) {
          button.disabled = false;
          button.removeAttribute('data-sold-out');
          label.textContent = button.getAttribute('data-add-label');
        } else {
          button.disabled = true;
          button.setAttribute('data-sold-out', '');
          label.textContent = 'Sold out';
        }
      }
      if (variant.featured_media) showMedia(root.querySelector('[data-gallery]'), String(variant.featured_media.id));

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) { if (e.target.closest('[data-option-group]')) update(); });
    update();
  }

  /* ---------- Collection filters & sort ---------- */
  function initFacets(form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      submit();
    });
    form.addEventListener('input', function (e) {
      if (!e.target.matches('input[type="number"]')) return;
      clearTimeout(timer);
      timer = setTimeout(submit, 700);
    });
    function submit() {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (key) {
        if (params.get(key) === '') params.delete(key);
      });
      window.location.search = params.toString();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
    document.querySelectorAll('[data-facets-form]').forEach(initFacets);
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  });
})();
